import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export const HeroSection = () => {
  return <section className="w-full bg-gradient-to-r from-blue-800 to-blue-500 text-white" data-id="element-1188">
      <div className="container mx-auto px-4 py-12 md:py-24 flex flex-col md:flex-row items-center" data-id="element-1189">
        <div className="w-full md:w-1/2 mb-8 md:mb-0" data-id="element-1190">
          <h1 className="text-4xl md:text-6xl font-bold mb-4" data-id="element-1191">
            Give Tech a Second Life
          </h1>
          <p className="text-xl md:text-2xl mb-8" data-id="element-1192">
            Buy Used Devices with Confidence
          </p>
          <div className="flex flex-col sm:flex-row gap-4" data-id="element-1193">
            <Link to="/category/smart-phones" className="bg-white text-blue-700 px-6 py-3 rounded-md font-medium text-lg hover:bg-opacity-90 transition-all flex items-center justify-center" data-id="element-1194">
              Shop Now <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-1195" />
            </Link>
            <Link to="/sell" className="border border-white text-white px-6 py-3 rounded-md font-medium text-lg hover:bg-white hover:bg-opacity-10 transition-all flex items-center justify-center" data-id="element-1196">
              Sell Your Device
            </Link>
          </div>
        </div>
        <div className="w-full md:w-1/2 flex justify-center" data-id="element-1197">
          <div className="relative" data-id="element-1198">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/nVeczu4C6hUnUDxqpyeP1K/image.png" alt="Multiple devices including iPhone, Apple Watch, tablet, and laptop" className="max-w-full" data-id="element-1199" />
          </div>
        </div>
      </div>
    </section>;
};